<template>
  <div id="app">
    <el-container>
      <Header></Header>
      <router-view></router-view>
      <Footer></Footer>
    </el-container>
  </div>
</template>

<script>
import Header from "./components/Header";
import Footer from "./components/Footer";


export default {
  name: "App",
  components: {
    Header,
    Footer,
  },
};
</script>

<style lang="scss">
* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}

a {
  text-decoration: none;
}

.el-container {
  display: block !important;

  // overflow: hidden;
  .el-header,
  .el-main,
  .el-footer {
    padding: 0;
  }

  .el-main {
    position: relative;
    overflow: hidden;
    top: 80px;
    margin-bottom: 105px;

    @media screen and (max-width: 768px) {
      top: 0px;
    }
  }
}
		.Icon_group {
			position: fixed;
			right: 100px;
			height: 240px;
			top: 50%;
			z-index: 99999;
			display: flex;
			justify-content: space-between;
			flex-direction: column;
			@media screen and (max-width:1300px) {
				height: 163px;				
			}
			@media screen and (max-width:768px) {
				right: 33px;	
			}
			.Icon_item {
				width: 60px;
				height: 60px;
				cursor: pointer;
				@media screen and (max-width:1300px) {
					height: 40px;	
					width: 40px;
				}
				img {
					width: 100%;
				}
			}
		}
body::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 10px;
  /*高宽分别对应横竖滚动条的尺寸*/
  height: 1px;
}

body::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 10px;
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: #535353;
}

body::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 10px;
  background: #ededed;
}

.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #d0a971; // 进行修改背景和字体
  color: #fff;
}
</style>
